import _ from 'lodash';
import { LoremIpsum } from 'lorem-ipsum';
import Dataset from '../../model/Dataset';
import { Mock } from '../../model/Mock';
import { TEXT_ALLERGENS } from '../allergens.data';
import { CARBONSCORE } from '../carbonscore.data';
import { SAUCES } from '../sauces.data';
import { SIDES } from '../sides.data';
import { WAITINGTIME } from '../waitingtime.data';
import { DISHES, DISHES_EN } from './dishes.data';

const lorem = new LoremIpsum();

export class DishesMock implements Mock {
  options: DishesMockOptions;

  constructor(options: Partial<DishesMockOptions> = {}) {
    const defaultOptions: DishesMockOptions = {
      minDishes: 1,
      maxDishes: 4,
      minPrice: 0.25,
      maxPrice: 9.99,
      minAllergens: 0,
      maxAllergens: 6,
      minOrigins: 0,
      maxOrigins: 4,
      sides: true,
      sauces: true,
      waitingtime: false,
      english: true,
      price: true,
      price2: false,
      carbonscore: false,
      origins: {},
    };
    this.options = _.merge({}, defaultOptions, options);
  }

  make(): Dataset {
    const numberOfDishes = _.random(this.options.minDishes, this.options.maxDishes);
    const dataset: Dataset = {};
    for (let i = 1; i <= numberOfDishes; i += 1) {
      dataset[`dish${i}_enable`] = true;
      if (this.options.price)
        dataset[`dish${i}_price`] = _.round(
          _.random(this.options.minPrice, this.options.maxPrice, true),
          2,
        ).toString();
      if (this.options.price2)
        dataset[`dish${i}_price2`] = _.round(
          _.random(this.options.minPrice, this.options.maxPrice, true),
          2,
        ).toString();
      if (this.options.carbonscore) dataset[`dish${i}_carbonscore`] = _.sample(CARBONSCORE) || '0';
      dataset[`dish${i}_name`] = this.name();
      if (this.options.english) dataset[`dish${i}_name_english`] = this.englishName();
      dataset[`dish${i}_allergens`] = _.sampleSize(
        TEXT_ALLERGENS,
        _.random(this.options.minAllergens, this.options.maxAllergens),
      ).join(',');
      dataset[`dish${i}_origins`] = _.sampleSize(
        Object.keys(this.options.origins),
        _.random(this.options.minOrigins, this.options.maxOrigins),
      ).join(',');
      if (this.options.ingredients)
        dataset[`dish${i}_ingredients`] = lorem.generateWords(_.random(6, 19));
      if (Math.random() > 0.4) dataset[`dish${i}_origin`] = 'France';
    }
    for (let i = numberOfDishes + 1; i <= this.options.maxDishes; i += 1) {
      dataset[`dish${i}_enable`] = false;
    }
    if (this.options.sides) dataset.sides = _.sample(SIDES) || '###';
    if (this.options.sauces) dataset.sauces = _.sample(SAUCES) || '###';
    if (this.options.waitingtime) dataset.waiting_time = _.sample(WAITINGTIME) || '0';

    return dataset;
  }

  name() {
    return _.sample(DISHES) || '#';
  }

  englishName() {
    return _.sample(DISHES_EN) || '#';
  }
}

export interface DishesMockOptions {
  ingredients?: boolean;
  minDishes: number;
  maxDishes: number;
  minPrice: number;
  maxPrice: number;
  minAllergens: number;
  maxAllergens: number;
  minOrigins: number;
  maxOrigins: number;
  sides: boolean;
  sauces: boolean;
  waitingtime: boolean;
  carbonscore: boolean;
  price: boolean;
  price2: boolean;
  origins: { [key: string]: unknown };
  english?: boolean;
}
